import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faPowerOff,
  faUsers,
  faVideo,
  faUserCheck,
  faFolder,
  faBell,
} from "@fortawesome/free-solid-svg-icons";
import { Navbar, Nav, Offcanvas } from "react-bootstrap";
import { useState } from "react";
import "./Header.css";
import LogoutModal from "../common_components/common-modal/logout-modal/Logout";
import Cookies from "js-cookie";
const navLinks = [
  {
    path: "/student/detail",
    label: "Student List",
    icon: "/assets/images/header/img1.png",
  },
  {
    path: "/student/recording",
    label: "Recording List",
    icon: "/assets/images/header/img2.png",
  },
  {
    path: "/student/attendance",
    label: "Attendance List",
    icon: "/assets/images/header/img3.png",
  },
  {
    path: "/student/notification",
    label: "Notification",
    icon: "/assets/images/header/img4.png",
  },
  {
    path: "/student/all-recording",
    label: "All Recording List",
    icon: "/assets/images/header/img5.png",
  },
];

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    );
  };

  const handleLogout = () => {
    // Your logout logic here
    navigate("/logout");
  };

  const [expanded, setExpanded] = useState(false);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  return (
    <div className="custom-topbar">
      <div className="topbar-wrapper desktop_header">
        {/* Logo */}
        <Link className="header-brand" to="/student/detail">
          <div
            className="logo-img"
            // onClick={() => {
            //   Cookies.remove("super_admin_security");
            // }}
          >
            <img
              src="/assets/images/logo/logo.png"
              className="header-brand-img"
              alt="Logo"
            />
          </div>
        </Link>

        {/* Navigation */}
        <Navbar className="custom-navbar">
          <Navbar.Collapse id="basic-navbar-nav" className="show">
            <Nav className="top-nav">
              {navLinks.map((link) => (
                <Nav.Link
                  key={link.path}
                  as={Link}
                  to={link.path}
                  className={`nav-item ${isActive(link.path) ? "active" : ""}`}
                  onClick={() => setExpanded(false)}
                >
                  <img src={link?.icon} className="inner_icon" />

                  <span>{link?.label}</span>
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {/* Logout */}
        <div className="logout-wrapper">
          <button
            type="button"
            className="btn-logout"
            onClick={() => setShowLogoutModal(true)}
          >
            <FontAwesomeIcon icon={faPowerOff} />

            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* ================= MOBILE HEADER ================= */}

      <div className="mobile_topbar">
        <div className="mobile_header_wrapper">
          {/* Menu Button */}
          <button
            type="button"
            className="mobile_menu_button"
            onClick={() => setShowOffcanvas(true)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>

          {/* Logo */}
          <Link
            to="/"
            className="mobile_header_logo"
            onClick={() => setShowOffcanvas(false)}
          >
            <img src="/assets/images/logo/logo.png" alt="Logo" />
          </Link>

          {/* Logout */}
          <button
            type="button"
            className="mobile_logout_button"
            onClick={handleLogout}
          >
            <FontAwesomeIcon icon={faPowerOff} />
          </button>
        </div>

        {/* ================= OFFCANVAS ================= */}

        <Offcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          placement="start"
          className="mobile_offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img
                src="/assets/images/logo/logo.png"
                alt="Logo"
                className="mobile_offcanvas_logo"
              />
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div className="mobile_nav_links">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`mobile_nav_item ${
                    isActive(link.path) ? "active" : ""
                  }`}
                  onClick={() => setShowOffcanvas(false)}
                >
                  <img
                    src={link?.icon}
                    className="mobile_nav_icon"
                    alt={link?.label}
                  />

                  <span>{link?.label}</span>
                </Link>
              ))}

              {/* Logout */}

              <button
                type="button"
                className="mobile_nav_logout"
                onClick={handleLogout}
              >
                <FontAwesomeIcon icon={faPowerOff} />

                <span>Logout</span>
              </button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      <LogoutModal
        show={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
      />
    </div>
  );
};

export default Header;
